import { App } from '@Modules/App';
import { Common } from '@Modules/Common';
import { artworkType, mockupsPanels, printArea } from './constants';
import { appConfig as $config } from '../../../app.config';

export const mapping = {
  artworkEdit: (res, isLicensor) => {
    const data = res.object ? res.object : res;

    let pantones =
      data.pantones && data.pantones.length
        ? data.pantones
        : [
          {
            name: '',
            number: '',
            hexadecimal: ''
          }
        ];
    data.selectTrims = data.selectTrims && data.selectTrims.length ? data.selectTrims : [{}];
    data.selectStamps = data.selectStamps && data.selectStamps.length ? data.selectStamps : [{}];
    data.selectBlanks = mapping.selectBlanks(data.selectBlanks);

    let licensor = $storage.get($config.storagekey.licensor);
    const defaults = res.defaults ? mapping.defaults(res.defaults) : {};

    return {
      ...data,
      pantones,
      accountDelegations: isLicensor ? licensor : res.accountDelegations,
      licensorRestrictions: data.licensorRestrictions || {
        colors: {},
        channels: {},
        blankCategories: {},
        territories: []
      },
      licensorRestrictionsNames: {
        colors: mapping.getLicensorRestrictionsNames(data.licensorRestrictions?.colors, defaults.ColorsRestrictions),
        channels: mapping.getLicensorRestrictionsNames(
          data.licensorRestrictions?.channels,
          defaults.ChannelsRestrictions
        ),
        blankCategories: mapping.getLicensorRestrictionsNames(
          data.licensorRestrictions?.blankCategories,
          defaults.BlankCategoriesRestrictions
        )
      },
      aopTransform: Object.values($config.aopTransform)
    };
  },
  artworkSave: (formData, isLicensor, artworkType) => {
    const content = App.pageData('currenteditedcontent');
    const versionFiles = JSON.parse(App.pageData('currenteditedcontent.versionFilesStringified') || '[]');

    let shortArtworks = App.pageData('currenteditedcontent.shortArtworks');
    let backgroundColor = App.pageData('currenteditedcontent.backgroundColor');

    let textAreas = App.pageData('currenteditedcontent.textAreas') || undefined;
    textAreas = (textAreas || []).reduce((acc, ta, index) => {
      acc[`textArea${index + 1}`] = ta;
      return acc;
    }, {});

    const templatesProperties =
      !content.templatesProperties ? null : Object.keys(content.templatesProperties).reduce((acc, key, index) => {
        acc[key] = {
          ...content.templatesProperties[key],
          textProperties: (content.templatesProperties[key].textProperties || []).reduce((acc, ta, index) => {
            acc[`textArea${index + 1}`] = ta;
            return acc;
          }, {}),
          imageProperties: (content.templatesProperties[key].imageProperties || []).reduce((acc, ap, index) => {
            acc[`centralArtwork${index + 1}`] = ap;
            return acc;
          }, {}),
        };

        return acc;
      }, {});

    backgroundColor = $.isEmptyObject(backgroundColor) ? null : backgroundColor;

    const shortArtworksCounters = { centralArtwork: 0, pattern: 0 };
    shortArtworks = $.isEmptyObject(shortArtworks) ? null : shortArtworks.reduce((acc, sa) => {
      if (sa.artworkType === 'Central') {
        shortArtworksCounters.centralArtwork += 1;
        acc[`centralArtwork${shortArtworksCounters.centralArtwork}`] = sa;
        return acc;
      }

      shortArtworksCounters.pattern += 1;
      acc[`pattern${shortArtworksCounters.pattern}`] = sa;
      return acc;
    }, {});

    const clonedFormData = { ...formData };
    delete clonedFormData.artworkFiles;
    delete clonedFormData.versionName;
    delete clonedFormData.colorGroup;
    delete clonedFormData.autoBlackVersion;
    delete clonedFormData.licensorId;
    delete clonedFormData.artworkPlacement;
    delete clonedFormData.artworkSize;
    delete clonedFormData.artworkBackgroundColor;
    delete clonedFormData.artworkTemplate;
    delete clonedFormData.artworkOffset;
    delete clonedFormData.rotate;
    delete clonedFormData.upscale;
    delete clonedFormData.upscaleToFill;
    delete clonedFormData.text;
    delete clonedFormData.fontColor;
    delete clonedFormData.fontSize;
    delete clonedFormData.fontFamily;
    delete clonedFormData.isPersonalization;
    delete clonedFormData.gravity;

    const licensor = $storage.get($config.storagekey.licensor);
    const accountId = isLicensor ? licensor?.[0]?.id : formData.licensorId;

    const artwork = App.pageData('artwork');

    return {
      ...clonedFormData,
      ...{
        tags: content.tags ? content.tags : [],
        collections: content.collections ? content.collections : [],
        bulletPoints: content.bulletPoints ? content.bulletPoints : [],
        minPrice: content.minPrice,
        checkedPartTypes: content.checkedPartTypes,
        screenPrintingFiles: mapping.screenPrintingFilesFormData(content.screenPrintingFiles),
        files: [],
        versionFiles,
        licensorRestrictions: {
          territories: formData.distributionTerritories ? formData.distributionTerritories.split(';') : ['Worldwide'],
          channels: content.licensorRestrictions?.channels,
          blankCategories: content.licensorRestrictions?.blankCategories,
          colors: content.licensorRestrictions?.colors
        },
        distributionTerritories: formData.distributionTerritories.split(';'),
        selectTrims: $.map(content.selectTrims, function (o) {
          if (o.id) return o;
        }),
        selectStamps: $.map(content.selectStamps, function (o) {
          if (o.id) return o;
        }),
        selectBlanks: content.selectBlanks,
        styleGuide: content.styleGuide && content.styleGuide.id ? content.styleGuide : null,
        brief: content.brief && content.brief.id ? content.brief : null,
        selectDistributionChannels: content.selectDistributionChannels,
        pantones: content.pantones,
        isDetachedFromAccountBlanks: content.isDetachedFromAccountBlanks,
        UpdateMockupsFiles: content.UpdateMockupsFiles || false,
        screenNumberOfColors: content.screenNumberOfColors,
        defaultMockupPanel: content.defaultMockupPanel,
        accountId: accountId || artwork?.accountId,
        containsLegalTagLine: formData.containsLegalTagLine === 'on',
        printType: 'Placement',
        aopFiles: content.aopFiles,
        artworkType,
        shortArtworks,
        backgroundColor: formData.isDtg === 'on' ? null : (backgroundColor || null),
        templatesProperties,
        textAreas,
        isDtg: formData.isDtg === 'on',
        scalePatternToFill: formData.upscaleToFill === 'on',
      }
    };
  },
  screenPrintingFilesFormData: (files) => {
    files.forEach((file) => {
      file.pantoneName = $(`input[name="pantoneName"][data-id="${file.id}"]`).val();
      file.colorPallete = {
        Cyan: $(`input[name="Cyan"][data-id="${file.id}"]`).val() * 1,
        Magenta: $(`input[name="Magenta"][data-id="${file.id}"]`).val() * 1,
        Yellow: $(`input[name="Yellow"][data-id="${file.id}"]`).val() * 1,
        Key: $(`input[name="Key"][data-id="${file.id}"]`).val() * 1
      };
      file.order = $(`tr#${file.id}`).index() + 1;
    });
    return files;
  },
  selectBlanks: (data, defaultMockupPanel) => {
    if (!data?.length) return [];
    data.forEach((blank) => {
      if (!blank.selectedStatus) {
        blank.selectedStatus = $Lang.blanks.SelectedFromArtwork;
      }
      blank.variants.forEach((variant) => {
        variant.select = variant.approved || variant.select;
      });
      // Approval Item mapping
      blank.approveItem = Common.mapping.approvalObject(blank.approveItem);

      blank.defaultMockupPanel = blank.defaultMockupPanel || defaultMockupPanel || mockupsPanels[0].key;
    });
    return data;
  },
  defaults: (data) => {
    let newArr = [];
    $.each(data, function (k, v) {
      newArr[v.key] = v.values;
    });
    return Object.assign({}, newArr);
  },
  territories: (data) => {
    let cont = [];
    $.each(data, (k, v) => {
      if (v.Item1 != 'Worldwide') {
        cont.push({ idx: v.Item1.replace(' ', '').toLowerCase(), name: v.Item1, countries: v.Item2 });
      }
    });
    return cont;
  },
  licensorRestrictions: (data) => {
    let cont = [];
    $.each(data, (k, v) => {
      cont.push({
        idx: v.Item1.replace(' ', '').toLowerCase(),
        name: v.Item1,
        items: v?.Item2?.map((item) => ({ name: item, idx: `${v.Item1}__${item}` }))
      });
    });

    return cont;
  },
  licensorRestrictionsSelected: (data, defaults) => {
    const selected = Object.keys(data).reduce((acc, key) => {
      data[key]?.forEach((item) => acc.push(`${key}__${item}`));

      return acc;
    }, []);

    const defaultsCount = defaults.reduce((acc, item) => {
      acc += item.Item2?.length || 0;

      return acc;
    }, 0);

    return selected.length === defaultsCount ? ['All'] : selected;
  },
  getLicensorRestrictions: (idxArray, defaults) => {
    if (!idxArray?.length) {
      return null;
    }

    if (idxArray[0] === 'All') {
      return defaults.reduce((acc, item) => {
        acc[item.Item1] = item.Item2;

        return acc;
      }, {});
    }

    return idxArray.reduce((acc, item) => {
      const [key, value] = item.split('__');

      if (acc[key]) {
        acc[key].push(value);
      } else {
        acc[key] = [value];
      }

      return acc;
    }, {});
  },
  getLicensorRestrictionsNames: (data, defaults) => {
    if (!data) {
      return [];
    }

    const defaultsCount = (defaults || []).reduce((acc, item) => {
      acc += item.Item2?.length || 0;

      return acc;
    }, 0);

    const names = Object.values(data).reduce((acc, items) => acc.concat(items), []);

    return names.length === defaultsCount ? ['All'] : names;
  },
  filesSelectList: () => {
    let selectList = $.extend(true, [], $config.filesModel);

    selectList.sort(function (a, b) {
      return a.order - b.order;
    });

    selectList[0].selected = true;

    return selectList;
  },
  prepareShortArtwork: (artwork) => {
    return artwork ? {
      id: artwork.id,
      standartId: artwork.standartId,
      accountId: artwork.accountId,
      versionFiles: artwork.versionFiles,
      title: artwork.title,
      titleNormalize: artwork.titleNormalize,
      brand: artwork.brand,
      subbrand: artwork.subbrand,
      externalId: artwork.externalId,
      artworkType: artwork.artworkType || artworkType.central,
    } : null;
  },
  prepareComplexArtwork: (artwork) => {
    artwork.textAreas = Object.values(artwork.textAreas || {});

    const templatesProperties = App.pageData('currenteditedcontent.templatesProperties') || {};

    Object.keys(templatesProperties).forEach((key) => {
      templatesProperties[key] = {
        printArea: templatesProperties[key].printArea,
        imageProperties: Object.values(templatesProperties[key].imageProperties || {}),
        textProperties: Object.values(templatesProperties[key].textProperties),
      };
    });

    App.pageData('currenteditedcontent.templatesProperties', templatesProperties);
  },
};
